import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.css']
})
export class ContactInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
